import useLocalStorageState from "use-local-storage-state";
import OpenDotIcon from "@/icons/open-dot-icon.svg";
import ClosedDotIcon from "@/icons/closed-dot-icon.svg";
import { getDayOfWeek, getOpenTime, getCloseTime, isLocationCurrentlyOpen } from '@/Utils';

const LocationSelectorItem = ({ retailer, onHandleChange, closeAgeGate, setDutchieRetailerAndFulfillment }) => {
	const [dutchieRetailer, setDutchieRetailer] = useLocalStorageState("dutchie_retailer", null);
	const [fulfillment, setFulfillment] = useLocalStorageState("cp_fulfillment_type", null);
	const buttonClass = window.ageGate.buttonClass;
	const dayOfWeek = getDayOfWeek();
	
    const todaysHours = retailer?.hours && retailer.hours?.pickup ? retailer.hours.pickup[dayOfWeek] : null;

	console.log(retailer);

	console.log(todaysHours);

	let isOpen = false;
	let opensAt = null;
	let closesAt = null;

	if (todaysHours) {
		isOpen = isLocationCurrentlyOpen( todaysHours );
		opensAt = getOpenTime( todaysHours);
		closesAt = getCloseTime( todaysHours);
	}

	const updateLocation = (retailer, key) => {
		setDutchieRetailerAndFulfillment(retailer, key);
		
		if (onHandleChange) {
			onHandleChange(key);
		}
	}

	function goToMenuPage(retailer) {
		setDutchieRetailer(retailer);
		setFulfillment("PICKUP");
		closeAgeGate();
	}

	return (
		<div className="location-selector-item-store">
			<div className="location-selector-item-content">
				<header className="location-selector-item-header">
					<div className="location-selector-item-hours">
						<div className="location-status-wrap">
							{isOpen ? (
							<>
								<OpenDotIcon />
								{closesAt && (
									<span className="time">Order until {closesAt}</span>
								)}
							</>
							) : (
							<>
								<ClosedDotIcon />
								<span className="status closed">Closed</span> |{" "}
								{opensAt && (
									<span className="time">Order at {opensAt}</span>
								)}
							</>
							)}
						</div>
					</div>
					<div className="location-selector-item-store-details">
						<h3>{retailer.name}</h3>
						<p className="location-selector-item-address">
							{retailer.line1} <br />
							{retailer.city ? `${retailer.city},` : '' } {retailer.state} {retailer.zipCode}
						</p>
					</div>
				</header>
				<div className="menu-type-buttons">
					{retailer.coming_soon ? (
						<p className="location-coming-soon">Coming Soon</p>
					) : (
						<>
							{Object.entries(retailer.fulfillment).map(([key, value]) => (
								value ? (
									<button className={`${buttonClass} btn-sm`} key={key} onClick={() => updateLocation(retailer, key) }>
										{key === 'curbsidePickup' ? 'Shop Curbside' : `Shop ${key}`}
									</button>
								) : null
							))}
							{retailer?.pageLink ? (
								<a href={retailer.pageLink} onClick={() => goToMenuPage(retailer)} className="btn-sm btn-white-outline">
									View Store
								</a>
							) : null}
						</>
					)}
				</div>
			</div>
		</div>
	);
}
export default LocationSelectorItem;